import { useEffect, useMemo } from "react";

import { setSocketConnectionAction } from "@main/context/App/App.actions";
import { useAppDispatch } from "@main/context/App/App.context";
import { io, Socket } from "socket.io-client";

import environments from "../environments";

export default function useSocket<U extends EventSourceEventMap, V extends EventSourceEventMap>(teamId?: string) {
  const socket: Socket<U, V> | undefined = useMemo(() => createSocketConnection(teamId), [teamId]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSocketConnectionAction(socket));

    return () => {
      socket?.disconnect();
      dispatch(setSocketConnectionAction(undefined));
    };
  }, [dispatch, socket]);

  return { socket };
}

function createSocketConnection(teamId?: string) {
  if (!teamId) return;

  return io(`${environments.socketioHost}/dashboard`, {
    upgrade: false,
    transports: ["websocket"],
    query: { team_id: teamId },
  });
}
